import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (v) =>
  `${new Intl.NumberFormat("tr-TR").format(Number(v || 0))} ₺`;

export const fileUrl = (path) =>
  path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : "";

export const mapEmbedUrl = (address) =>
  address && address.trim() ? `https://www.google.com/maps?q=${encodeURIComponent(address.trim())}&output=embed` : "";

export const mapLinkUrl = (business) => {
  if (business?.maps_url && business.maps_url.trim()) return business.maps_url.trim();
  return business?.address ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(business.address.trim())}` : "";
};

export const phoneDigits = (v) => (v || "").replace(/\D/g, "");
export const isValidTrPhone = (v) => phoneDigits(v).length === 11;
export const PHONE_HINT = "Örnek: 05xx xxx xx xx (11 rakam)";

// Convert #RRGGBB to a Tailwind CSS var friendly "H S% L%" triplet string
export function hexToHsl(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, sat = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    sat = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  return `${Math.round(hue * 360)} ${Math.round(sat * 100)}% ${Math.round(l * 100)}%`;
}

export const THEME_PRESETS = [
  { name: "İndigo", color: "#4F46E5" },
  { name: "Zümrüt", color: "#10B981" },
  { name: "Gül", color: "#E11D48" },
  { name: "Kehribar", color: "#F59E0B" },
  { name: "Gökyüzü", color: "#0EA5E9" },
  { name: "Menekşe", color: "#7C3AED" },
  { name: "Turkuaz", color: "#14B8A6" },
  { name: "Antrasit", color: "#0F172A" },
];

export const SUB_STATE = {
  active: { label: "Pro", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  free: { label: "Ücretsiz", cls: "bg-secondary text-muted-foreground border-border" },
  suspended: { label: "Askıya Alındı", cls: "bg-amber-100 text-amber-700 border-amber-200" },
};

export const DAY_LABELS = {
  monday: "Pazartesi", tuesday: "Salı", wednesday: "Çarşamba", thursday: "Perşembe",
  friday: "Cuma", saturday: "Cumartesi", sunday: "Pazar",
};
export const DAY_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const STATUS_LABELS = {
  pending: "Bekliyor", confirmed: "Onaylandı", completed: "Tamamlandı", cancelled: "İptal edildi",
};
export const STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-700 border-amber-200",
  confirmed: "bg-blue-100 text-blue-700 border-blue-200",
  completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
  cancelled: "bg-red-100 text-red-700 border-red-200",
};
